var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRekonic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1420.93 411.43",
    style: {
      enableBackground: "new 0 0 1420.93 411.43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#008B8B;}\r\n\t.st2{fill:#414141;}\r\n\t.st3{font-family:'MyriadPro-Regular';}\r\n\t.st4{font-size:72.4456px;}\r\n\t.st5{fill:#E1E4E6;}\r\n\t.st6{font-family:'FuturaBT-Book';}\r\n\t.st7{font-size:279.4284px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 415.6123 356.8546)",
    className: "st0 st3 st4"
  }, "Business, Your Way")), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.83,216.16c35.82-35.72,71.03-70.83,107.26-106.96c-25.66,0-50.02-0.07-74.38,0.13 c-1.94,0.02-4.28,1.42-5.74,2.87c-34.34,34.21-68.59,68.52-102.83,102.83c-0.35,0.35-0.42,0.99-1.09,2.64 c16.85,16.66,34.07,33.62,51.2,50.67c19.57,19.49,38.97,39.15,58.64,58.53c5.83,5.74,8.3,12.12,5.09,19.69 c-3.08,7.27-9.48,10.11-17.07,10.11c-44.54,0.05-89.08,0.03-133.61,0c-1.08,0-2.15-0.29-3.92-0.55c-0.15-2.86-0.42-5.57-0.42-8.29 c-0.03-42,0.08-84-0.1-126c-0.03-7.83,2.38-13.98,7.98-19.54c39.78-39.53,79.24-79.39,119.27-118.66 c4.12-4.04,11.25-6.94,17.04-7.03c38.61-0.61,77.23-0.29,115.85-0.34c8.22-0.01,15.07,2.41,18.63,10.38 c3.68,8.24-0.04,14.44-5.84,20.22c-34.55,34.41-68.99,68.92-103.46,103.41c-1.95,1.95-3.78,4.01-6.18,6.57 c21.05,20.98,41.78,41.61,62.48,62.27c16.36,16.33,32.82,32.56,48.98,49.07c9.85,10.06,5.51,25.47-8.12,27.59 c-4.47,0.69-10.96-1.49-14.22-4.71C290.29,306.76,245.74,262.04,199.83,216.16z M116.3,258.78c0,20.66,0,42.63,0,64.53 c22.44,0,44.18,0,64.62,0C159.4,301.83,137.48,279.94,116.3,258.78z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 399.2559 276.0714)",
    className: "st5 st6 st7"
  }, "Rekonic"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRekonic);
export default __webpack_public_path__ + "static/media/rekonic.39344ae35753c92d13774d743352eb4c.svg";
export { ForwardRef as ReactComponent };